import React from 'react';

import Drawer from '@material-ui/core/Drawer';
import styled from 'src/ui/library/styled';
import styles from './styles';

const DrawerBase = props => {
  const { anchor, classes, children, isMobile, topFixed, onClose, ...otherProps } = props;

  const handleOnClose = () => {
    onClose(props.anchor);
  };

  return (
    <Drawer
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor={anchor}
      onClose={handleOnClose}
      {...otherProps}>
      {children}
    </Drawer>
  );
};

export default styled(DrawerBase)(styles);
